var list = {
	1:"[GtoV] Only allow the Grid charge the Vehicle",
	2:"[BtoV] Only allow the Battery charge the Vehicle",
	3:"[GtoB] Only allow the Grid charge the Battery",
	4:"[GtoV > BtoV] Don't allow the Grid charge the Battery, the Vehicle use the Grid first, then  the Battery",
	5:"[GtoV > GtoB] If no Vehicle is charging,use the Grid charge the Battery, otherwise only allow to use the Grid charge the Vehicle", 
	6:"[BtoV > GtoV] Don't allow the Grid charge the Battery, and when the Vehicle is charging, use the Battery first then the Grid",
	7:"[BtoV > GtoB] If no Vehicle is charging, use the Grid charge the Battery, otherwise use the Battery charge the Vehicle.",
	8:"[GtoV > BtoV > GtoB] If no Vehicle is charging, use the Grid charge the Battery, otherwise use the Gird first, then the Battery",
	9:"[BtoV > GtoV > GtoB] If no Vehicle is charging, use the Grid charge the Battery, otherwise use the Battery first, then the Grid",
	10:"[GtoB > GtoV] Use the Grid charge the Battery first, then use the Grid charge the Vehicle",
	11:'[BtoG] Only allow Battery connect to Grid',
	12:'[PtoB] Only allow PV to Battery',
	13:'[BtoG > BtoV] Battery shall be priority connect to Grid, when vehicle comes, Battery can also be used to charge the vehicle',
	14:'[PtoB > GtoV] When PV charge the Battery, if a vehicle comes, Grid will charge the vehicle',
	15:'[Max] Full power mode',
	16:'[Eco] Economic model',
	17:'[Auto] Automatic mode',
}
module.exports = list;